<template>
    <v-dialog v-model="status" content-class="new-address-dialog">
        <v-card class="add-new-address-card" v-if="mobileCheck">
            <v-form ref="form" v-model="valid" class="change-pass-form">
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                                <h4>{{ $t('address5') }}</h4>
                                <div class="add-new-address-close" @click="closeModal">
                                    &times;
                                    <div>{{ $t('sell8') }}</div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="myprofile-label">{{ $t('address6') }} *</span>
                                <v-text-field v-model="newAddress.name" :rules="[rules.required]"
                                              dense></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <h5>{{ $t('personal-info') }}</h5>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="myprofile-label">{{ $t('myprofile1') }} *</span>
                                <v-text-field v-model="newAddress.firstName"
                                              :rules="[rules.required]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="myprofile-label">{{ $t('myprofile2') }} *</span>
                                <v-text-field v-model="newAddress.lastName"
                                              :rules="[rules.required]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="myprofile-label">{{ $t('myprofile4') }} *</span>
                                <v-text-field v-model="newAddress.phoneNumber"
                                              :rules="[rules.required]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <h5>{{ $t('company-info') }}</h5>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="myprofile-label">{{ $t('company-name') }}</span>
                                <v-text-field v-model="newAddress.company"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="myprofile-label">VAT</span>
                                <v-text-field v-model="newAddress.vat" :rules="[rules.min]"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <h5>{{ $t('address10') }}</h5>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="myprofile-label">{{ $t('address11') }} *</span>
                                <v-text-field v-model="newAddress.street" :rules="[rules.required]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="myprofile-label">{{ $t('address12') }}</span>
                                <v-text-field v-model="newAddress.street1"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="last-row">
                            <v-col>
                                <span class="myprofile-label">{{ $t('address13') }} *</span>
                                <v-text-field v-model="newAddress.postCode" :rules="[rules.required]"
                                              placeholder=" "></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="myprofile-label">{{ $t('address14') }} *</span>
                                <v-text-field v-model="newAddress.city" :rules="[rules.required]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="country-container">
                                <span class="myprofile-label">{{ $t('address15') }} *</span>
                                <country-select class="country-select" :class="countryError ? 'error-msg' : ''"
                                                :whiteList="vin_countries" :rules="[rules.required]"
                                                v-model="country" :country="country"/>
                                <div v-if="countryError" class="v-text-field__details">
                                    <div class="v-messages theme--light error--text">
                                        <div class="v-messages__wrapper">
                                            <div class="v-messages__message">Required.</div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="addAddress-btn" v-on:click="addAddress" :disabled="!valid" text>
                        {{ $t('save') }}
                    </v-btn>
                    <v-btn class="cancel-btn" @click="closeModal">{{ $t('cancel') }}</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-card class="add-new-address-card" v-else>
            <v-form ref="form" v-model="valid" class="change-pass-form">
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                                <h4>{{ $t('address5') }}</h4>
                                <div class="add-new-address-close" @click="closeModal">
                                    &times;
                                    <div>{{ $t('sell8') }}</div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="myprofile-label">{{ $t('address6') }} *</span>
                                <v-text-field v-model="newAddress.name" :rules="[rules.required]"
                                              dense></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <h5>{{ $t('personal-info') }}</h5>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="myprofile-label">{{ $t('myprofile1') }} *</span>
                                <v-text-field v-model="newAddress.firstName"
                                              :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col>
                                <span class="myprofile-label">{{ $t('myprofile2') }} *</span>
                                <v-text-field v-model="newAddress.lastName"
                                              :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col>
                                <span class="myprofile-label">{{ $t('myprofile4') }} *</span>
                                <v-text-field v-model="newAddress.phoneNumber"
                                              :rules="[rules.required]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <h5>{{ $t('company-info') }}</h5>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="myprofile-label">{{ $t('company-name') }}</span>
                                <v-text-field v-model="newAddress.company"></v-text-field>
                            </v-col>
                            <v-col>
                                <span class="myprofile-label">{{ $t('invoice05') }}</span>
                                <v-text-field v-model="newAddress.vat" :rules="[rules.min]"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <h5>{{ $t('address10') }}</h5>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <span class="myprofile-label">{{ $t('address11') }} *</span>
                                <v-text-field v-model="newAddress.street" :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col>
                                <span class="myprofile-label">{{ $t('address12') }}</span>
                                <v-text-field v-model="newAddress.street1"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="last-row">
                            <v-col>
                                <span class="myprofile-label">{{ $t('address13') }} *</span>
                                <v-text-field v-model="newAddress.postCode" :rules="[rules.required]"
                                              placeholder=" "></v-text-field>
                            </v-col>
                            <v-col>
                                <span class="myprofile-label">{{ $t('address14') }} *</span>
                                <v-text-field v-model="newAddress.city" :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col class="country-container">
                                <span class="myprofile-label">{{ $t('address15') }} *</span>
                                <country-select class="country-select" :class="countryError ? 'error-msg' : ''"
                                                :whiteList="vin_countries" :rules="[rules.required]"
                                                v-model="country" :country="country"/>
                                <div v-if="countryError" class="v-text-field__details">
                                    <div class="v-messages theme--light error--text">
                                        <div class="v-messages__wrapper">
                                            <div class="v-messages__message">Required.</div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="addnewaddress-btn" v-on:click="addAddress" :disabled="!valid || addAdressButtonLoader" text>{{ $t('save') }}
                    </v-btn>
                    <v-btn class="cancel-btn" @click="closeModal">{{ $t('cancel') }}</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import vueCountryRegionSelect from 'vue-country-region-select'
    import {mapGetters, mapState} from "vuex";
    import {GCommon} from "@/store/getters";

    Vue.use(vueCountryRegionSelect)

export default {
    name: 'AddAddressModal',
    props: ['status', 'addAdressButtonLoader', 'newAddress', 'countryError'],
    data() {
        return {
            valid: true,
            rules: {
                required: value => !!value || 'Required.',
                min: value => !value.length ? true : value.length >= 10 || 'Min 10 characters'
            },
            vin_countries: {},
            countryMap: [],
            country: null,
        }
    },
    methods: {
        addAddress() {
            this.$nuxt.$emit('onAddAddressGetCountry', this.country)
            this.$nuxt.$emit('onAddAddress')
        },
        closeModal() {
            this.$nuxt.$emit('onCloseAddAddressModal')
        },
        getCountries() {
            this.vin_countries = Object.keys(this.countries);
            this.vin_countries.forEach((code) => {
                let allCountries = this.countries,
                    newCountry = {};
                newCountry.id = parseInt(allCountries[code].id);
                newCountry.code = code;
                newCountry.value = allCountries[code].value;
                this.countryMap.push(newCountry);
            })
        }
    },
    created() {
        this.getCountries();
    },
    computed: {
        ...mapState({
            countries: state => state.countries
        }),
        ...mapGetters({
            mobileCheck: GCommon.GET_MOBILE_VERSION
        })
    }
}
</script>

<style scoped>
.add-new-address-card small {
    padding-left: 28px;
}

.add-new-address-close {
    position: absolute;
    right: 67px;
    top: 45px;
    text-transform: uppercase;
    font-family: Arial, sans-serif;
    font-size: 24px;
    color: #B0B1B0;
    text-align: right;
    padding-right: 4px;
    font-weight: 300;
}

.add-new-address-close div {
    font-size: 16px;
    font-family: Roboto, sans-serif;
    text-transform: initial;
    position: relative;
    right: -4px;
}

.add-new-address-close:hover {
    cursor: pointer;
    color: var(--brand);
}

.country-select {
    webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    line-height: 32px;
    padding: 0;
    max-width: 100%;
    min-width: 0;
    width: 100%;
    border-bottom: 1px solid #b2b2b2;
    margin: 0;
    height: 50px;
    margin-top: 16px;
    padding-left: 15px;
    font-size: 19px;
    font-weight: 400;
    color: #333333;
    font-family: var(--base-font);
    background-color: #fff;
    margin-bottom: 8px;
}

.country-select:hover {
    border-color: var(--brand);
    cursor: pointer;
}

.country-select:focus,
.country-select:active {
    border-bottom: 2px solid #000000;
}

.country-select.error-msg {
    border-bottom: 1px solid red !important;
}

@media (max-width: 767px) {
    .add-new-address-close {
        right: 15px;
        top: 15px;
    }
}
</style>
<style>
.v-dialog.new-address-dialog {
    max-width: 1024px;
    border-radius: 15px;
}

.v-dialog.new-address-dialog h1 {
    color: #6F706F;
    position: relative;
    margin-bottom: 30px;
}

.v-dialog.new-address-dialog h5 {
    margin-bottom: 20px;
}

.v-dialog.new-address-dialog .v-input input {
    height: 50px;
    max-height: unset;
    margin-top: 0;
    padding-left: 15px;
    font-size: 19px;
    font-weight: 400;
    color: #333333;
}

.v-dialog.new-address-dialog .v-input input:hover {
    border-color: var(--brand);
}

.v-dialog.new-address-dialog .v-input .v-label {
    font-size: 24px;
    font-weight: 300;
    top: -10px;
    color: #5B5C5B;
}

.v-dialog.new-address-dialog .country-container .v-label {
    -webkit-transform: translateY(-18px) scale(.75);
    transform: translateY(-18px) scale(.75);
    height: 20px;
    line-height: 20px;
    top: -10px;
    position: relative;
}

.v-dialog.new-address-dialog .theme--light.v-card {
    padding: 30px 50px 50px;
    background: #F5F6F5;
}

.v-dialog.new-address-dialog .theme--light.v-card .v-card__text {
    padding: 0;
}

.v-dialog.new-address-dialog .theme--light.v-card .v-card__text .row > .col {
    padding-top: 5px;
    padding-bottom: 5px;
}

.v-dialog.new-address-dialog .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border: 0;
}

.v-dialog.new-address-dialog .last-row {
    margin-top: 20px;
}

.addnewaddress-btn {
    background: #024E7B !important;
    border-color: #024E7B !important;
    color: #FFF !important;
    width: 180px;
    margin-left: 28px;
    margin-bottom: 30px;
}

.addnewaddress-btn.v-btn--disabled {
    color: #FFF !important;
    opacity: 0.5;
}

.v-dialog.new-address-dialog .addnewaddress-btn {
    background: #E1C376 !important;
    color: #FFF !important;
    width: 200px;
    height: 45px !important;
    font-size: 18px;
    border-radius: 5px;
    text-transform: none;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    letter-spacing: 0;
    font-weight: lighter;
    -webkit-box-shadow: none;
    box-shadow: none;
    margin: 0;
}

.v-dialog.new-address-dialog .cancel-btn {
    background: transparent !important;
    color: #686968 !important;
    width: 200px;
    height: 45px !important;
    font-size: 18px;
    border-radius: 5px;
    text-transform: none;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    letter-spacing: 0;
    border: 1px solid #B1B2B1;
    font-weight: lighter;
    -webkit-box-shadow: none;
    box-shadow: none;
    margin: 0;
    margin-left: 25px;
}

.v-dialog.new-address-dialog .v-card__actions {
    margin-top: 10px;
}

.v-dialog.new-address-dialog .country-container .v-label {
    -webkit-transform: translateY(-18px) scale(.75);
    transform: translateY(-18px) scale(.75);
    height: 20px;
    line-height: 20px;
    top: -10px;
    position: relative;
}

.v-dialog.new-address-dialog .theme--light.v-text-field.v-input--has-state.error--text > .v-input__control > .v-input__slot:before {
    border-style: solid;
    border-width: thin 0 0;
}

.v-dialog.new-address-dialog .theme--light.v-text-field.v-input--has-state.error--text > .v-input__control > .v-input__slot input {
    border: 0;
}

@media (max-width: 767px) {
    .v-dialog.new-address-dialog .theme--light.v-card .v-card__text {
        padding: 16px;
    }

    .v-dialog.new-address-dialog .theme--light.v-card {
        padding: 10px !important;
    }

    .v-dialog.new-address-dialog h1 {
        font-size: 20px;
    }

    .v-dialog.new-address-dialog .addnewaddress-btn {
        width: 100%;
        margin-right: 0;
    }

    .v-dialog.new-address-dialog .cancel-btn {
        width: 100%;
        margin-left: 0 !important;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .v-dialog.new-address-dialog .v-card__actions {
        padding: 8px 12px;
        display: block;
    }
}
</style>
